import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  readAdminCustomerRouteParam,
  readRouteParam,
} from '../../../_utils/route-param.utils';
import { TranslateModule } from '@ngx-translate/core';
import ITreatment from '../../../_interfaces/ITreatment';
import { AdminEntityLoaderService } from '../../../_services/admin/admin-entity-loader.service';
import { AdminFormLayoutComponent } from '../../../components/admin-ui/admin-form-layout/admin-form-layout.component';
import { AdminPageHeaderComponent } from '../../../components/admin-ui/admin-page-header/admin-page-header.component';
import { AdminStatePanelComponent } from '../../../components/admin-ui/admin-state-panel/admin-state-panel.component';
import { FormTreatmentComponent } from '../../../components/forms/form-treatment/form-treatment.component';

@Component({
  selector: 'app-admin-treatment-detail',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    AdminPageHeaderComponent,
    AdminStatePanelComponent,
    AdminFormLayoutComponent,
    FormTreatmentComponent,
  ],
  templateUrl: './admin-treatment-detail.component.html',
  styleUrl: './admin-treatment-detail.component.scss',
})
export class AdminTreatmentDetailComponent implements OnInit {
  public customersId = 0;
  public treatmentsId = 0;
  public treatment: ITreatment | null = null;
  public loading = true;
  public hasError = false;
  readonly reload = (): void => this.load();

  constructor(
    private readonly route: ActivatedRoute,
    private readonly loader: AdminEntityLoaderService,
  ) {}

  get backLink(): any[] {
    return [
      '/administration',
      readAdminCustomerRouteParam(this.route, this.customersId) || this.customersId,
      'treatments',
    ];
  }

  ngOnInit(): void {
    this.customersId = readRouteParam(this.route, 'customers_id');
    this.treatmentsId = readRouteParam(this.route, 'treatments_id');
    this.load(true);
  }

  load(fromResolver = false): void {
    this.loading = true;
    this.hasError = false;

    if (fromResolver) {
      const treatment = (this.route.snapshot.data['treatment'] || null) as
        | ITreatment
        | null;
      if (treatment) {
        this.treatment = treatment;
        this.loading = false;
        return;
      }
    }

    this.loader.loadTreatment(this.customersId, this.treatmentsId).subscribe({
      next: (treatment) => {
        this.treatment = treatment;
        this.hasError = !treatment;
        this.loading = false;
      },
      error: () => {
        this.hasError = true;
        this.loading = false;
      },
    });
  }
}
